import { Ref, ref, watch } from '@nuxtjs/composition-api';
import Fuse, { IFuseOptions } from 'fuse.js';

export interface UseFuzzySearchOptionProps<T> {
  threshold?: number;
  keys?: string[];
  getFn?: (option: T) => string;
}

const useFuzzySearch = <T>(items: Ref<T[]>, options?: UseFuzzySearchOptionProps<T>) => {
  const fuse = ref<Fuse<T> | null>(null);

  const defaultOptions: IFuseOptions<T> = {
    threshold: 0.3,
  };

  watch(
    items,
    () => {
      if (items.value.length) {
        fuse.value = new Fuse(items.value, {
          ...defaultOptions,
          ...options,
        });
      }
    },
    { immediate: true },
  );

  const search = (query: string) => fuse.value?.search(query).map((result) => result.item) ?? [];

  return {
    search,
  };
};

export default useFuzzySearch;
